import { z } from "zod";

export const ZByggfuktSchema = z.object({
  // 5
  isActive: z.boolean().default(true),
  tekst: z.string(),
});

export type IByggfuktSchema = z.infer<typeof ZByggfuktSchema>;
